import * as React from "react";
import {
  NumpadButton,
  NumpadButtonDisplayTypes,
  NumpadIconButton,
  NumpadTextButton,
} from "@merrie/nmbrs-api";
import "./numpad-button.component.scss";

interface INumpadButtonComponentProps {
  button: NumpadButton;
  isFocused: boolean;
  onBlur: () => void;
  onClick: () => void;
  onFocus: () => void;
}

const getInnerHtml = (button: NumpadButton) => {
  switch (button.display) {
    case NumpadButtonDisplayTypes.ICON:
      return getInnerIcon(button as NumpadIconButton);
    case NumpadButtonDisplayTypes.TEXT:
      return getInnerText(button as NumpadTextButton);
    default:
      return null;
  }
};

const getInnerIcon = (button: NumpadIconButton) => button.icon;

const getInnerText = (button: NumpadTextButton) => button.text;

export const NumpadButtonComponent: React.FC<INumpadButtonComponentProps> = ({
  button,
  isFocused,
  onBlur,
  onClick,
  onFocus,
}) => {
  const buttonElement = React.useRef<HTMLButtonElement>(null);

  const [mouseFocused, setMouseFocused] = React.useState(false);

  React.useEffect(() => {
    if (buttonElement.current && isFocused) buttonElement.current.focus();
  });

  return (
    <button
      ref={buttonElement}
      key={123}
      className={`
        numpad-button 
        ${button.style} 
        ${isFocused ? "numpad-button-focused" : ""}
        ${isFocused && mouseFocused ? "numpad-button-mouse-focused" : ""}
        ${isFocused && !mouseFocused ? "numpad-button-keyboard-focused" : ""}`}
      onBlur={() => {
        setMouseFocused(false);
        onBlur();
      }}
      onFocus={() => onFocus()}
      onClick={() => onClick()}
      onMouseDown={() => setMouseFocused(true)}
      onKeyDown={(event) => {
        if (
          !["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(
            event.key
          )
        ) {
          return;
        }
        setMouseFocused(false);
      }}
    >
      <span>{getInnerHtml(button)}</span>
    </button>
  );
};
